module.exports = __webpack_public_path__ + "static/media/CaptureGLUE1.4dae79df.PNG";